import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  render() {
    const {
      onChange,
      disabled,
    } = this.props;

    const selectOptions = this.props.options;
    const optionItems = selectOptions.map((item) => {
      const itemDisabled = item.disabled || false;
      return (
        <MenuItem value={item.value} primaryText={item.label} key={item.value} disabled={itemDisabled} />
      );
    });

    const select = (
      <SelectField
        fullWidth
        value={this.state.value}
        disabled={disabled}
        onChange={(event, index, value) => {
          this.setState({
            value,
          }, () => {
            onChange(value);
          });
        }}
      >
        {optionItems}
      </SelectField>
    );

    return select;
  }
}

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.node,
      PropTypes.array,
    ]),
    labelString: PropTypes.string,
  })),
};

Select.defaultProps = {
  onChange: () => {},
  value: null,
  name: '',
  options: [{
    value: null,
    label: '-- Missing --',
  }],
  disabled: false,
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.js